import React from "react";
import { IconButton } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import BugReportOutlinedIcon from "@mui/icons-material/BugReportOutlined";
import CustomDropdownMenu from "../CustomDropdownMenu";
import { useFeedback } from "../../context/FeedbackContext";
import colors from "../../config/colors";

const FeedbackDropdown = () => {
  const { openFeedbackModal } = useFeedback();

  const dropdownItems = [
    {
      label: "Submit Feedback",
      icon: <ChatBubbleOutlineIcon />,
      iconColor: colors.black,
      textColor: colors.black,
      onClick: () => openFeedbackModal("feedback"),
    },
    {
      label: "Report a Bug",
      icon: <BugReportOutlinedIcon />,
      iconColor: colors.black,
      textColor: colors.black,
      onClick: () => openFeedbackModal("bug"),
    },
  ];

  return (
    <CustomDropdownMenu
      items={dropdownItems}
      placement="bottom-end"
      offset={[0, 8]}
      trigger={
        <IconButton
          aria-label="Report a bug"
          sx={{
            p: 1,
            "&:hover": {
              backgroundColor: "rgba(0, 0, 0, 0.04)",
            },
          }}
        >
          <ErrorOutlineIcon sx={{ fontSize: 24, color: colors.black }} />
        </IconButton>
      }
    />
  );
};

export default FeedbackDropdown;
